export default __webpack_public_path__ + "static/media/weight-sub-icon.319d5e34.svg";